import { useRef } from 'react'
import useVehicleId from './useVehicleId'
import { useAppStore } from '../store/useAppStore'

const allParams = [
  'startKm',
  'pNumber',
  'depotCode',
  'preview',
  'layoutFor',
  'customTab',
  'webView',
  'allowClose',
  'vehicleId',
]

// If params is not provided then it will give all URL available fields
export const useParamsFromURL = (
  params = allParams
): {
  [key: string]: string | undefined
} => {
  const vehicleId = useVehicleId()
  const depotCode = useAppStore((state) => state.depotCode)

  // To prevent unnecessary work use params just once when component is mounted and not use for every rerender)
  const ref = useRef({
    paramsFromURL: {},
    mounted: false,
  })

  if (!ref.current.mounted) {
    let paramsFromURL = {}
    try {
      const urlParams = new URLSearchParams(window.location.search)
      params.forEach((param) => {
        const paramValue = urlParams.get(param)
        paramsFromURL[param] = !['null', 'nil'].includes(paramValue as string)
          ? paramValue
          : undefined
      })
    } catch (e) {
      var queryParams = window.location.search
        .substr(1)
        .split('&')
        .reduce(function (q, query) {
          var chunks = query.split('=')
          var key = chunks[0]
          var value = chunks[1]
          q[key] = value
          return q
        }, {})
      params.forEach((param) => {
        paramsFromURL[param] = queryParams['projectId']
      })
    }

    ref.current.paramsFromURL = paramsFromURL
    // Prevent multiple function calls | Call only when component is mounted;
    ref.current.mounted = true
  }

  // If vehicle missing in URL, wait until user will write vehicleId in AddVehicleIdDialog
  if (!ref.current.paramsFromURL['vehicleId']) {
    ref.current.paramsFromURL['vehicleId'] = vehicleId
  }

  return {
    ...ref.current.paramsFromURL,
    // Use depotCode from store if it's not in URL
    // We need depotCode to send vehicle data
    // DepotCode is extracted from depots and instead depotCode the system uses depotNumber
    // But we need to ensure that depotCode is always present
    depotCode: depotCode || undefined,
  }
}
